import "../node_modules/@codat/orchard-ui/dist/index.css";
import "./index.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClientConfig } from "api/shared";
import * as React from "react";
import { CookiesProvider } from "react-cookie";
import { createRoot } from "react-dom/client";

import App from "./components/App";

const container = document.getElementById("root");
const root = createRoot(container!); // eslint-disable-line @typescript-eslint/no-non-null-assertion

const queryClient = new QueryClient(queryClientConfig);

root.render(
  <React.StrictMode>
    <CookiesProvider>
      <QueryClientProvider client={queryClient}>
        <App />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </CookiesProvider>
  </React.StrictMode>
);
